import TreeSelector from './index.vue'

TreeSelector.install = Vue => {
  Vue.component(TreeSelector.name, TreeSelector)
}

export default TreeSelector



// WEBPACK FOOTER //
// ./src/components/tree-selector/index.js